(function ($) {
    $.fn.inViewport = function (classname) {

        return this.each(function () {

            var ele = $(this),
                classname = classname,
                padding_top = 0,
                padding_bottom = 0;

            if (classname === undefined) classname = 'in-viewport';
            if (ele.data('viewport-padding-top') !== undefined) padding_top = ele.data('viewport-padding-top');
            if (ele.data('viewport-padding-bottom') !== undefined) padding_bottom = ele.data('viewport-padding-bottom');
            if (ele.data('viewport-padding') !== undefined) {
                padding_top = ele.data('viewport-padding');
                padding_bottom = ele.data('viewport-padding');
            }

            $(window).on('resize scroll', function () {
                var elementTop = ele.offset().top;
                var elementBottom = elementTop + ele.outerHeight();

                var viewportTop = $(window).scrollTop() + padding_top;
                var viewportBottom = viewportTop + $(window).height() - padding_top - padding_bottom;

                var isInViewport = elementBottom > viewportTop && elementTop < viewportBottom;

                ele.each(function () {
                    if (isInViewport) {
                        ele.toggleClass(classname, true);
                    } else {
                        if(ele.hasClass(classname)) ele.toggleClass('viewport-rendered', true);
                        ele.toggleClass(classname, false);
                    }
                });

                //set scroll thirds
                var scrollTop = $(window).scrollTop();
                var docHeight = $(document).height();
                var winHeight = $(window).height();
                var scrollPercent = (scrollTop) / (docHeight - winHeight);
                var scrollPercentRounded = Math.ceil(scrollPercent * 100 / 33.3333);

                $('.page').toggleClass('first-third', (scrollPercentRounded <= 1))
                    .toggleClass('second-third', (scrollPercentRounded === 2))
                    .toggleClass('third-third', (scrollPercentRounded >= 3));

            });

        });

    };


})(jQuery);
